import { inject } from 'aurelia';
import { IRouter } from '@aurelia/router';
import { EventApi } from '../../apis/event/event-api';
import { EventEntity } from '../../apis/event/event-entity';
import { EventAccessApi } from '../../apis/event-access/event-access-api';
import { AssociationApi } from '../../apis/association/association-api';

@inject(IRouter, EventApi, EventAccessApi, AssociationApi)
export class Invites {
    public invites: EventEntity[] = [];
    public isBusy: boolean = false;

    constructor(
        private readonly _router: IRouter,
        private readonly _eventApi: EventApi,
        private readonly _eventAccessApi: EventAccessApi,
        private readonly _associationApi: AssociationApi,
    ) {}

    public async loading(): Promise<void> {
        this.isBusy = true;
        try {
            this.invites = await this._eventApi.getInvites();
        } catch (error) {
            const apiError = error as { statusCode?: number };
            if (apiError.statusCode === 401) {
                void this._router.load('login?returnUrl=invites');
            }
        } finally {
            this.isBusy = false;
        }
    }

    public async acceptSharedEvent(event: EventEntity): Promise<void> {
        this.isBusy = true;
        try {
            await this._eventAccessApi.accept(event.id);
            this._removeInvite(event);
        } finally {
            this.isBusy = false;
        }
    }

    public async declineSharedEvent(event: EventEntity): Promise<void> {
        this.isBusy = true;
        try {
            await this._eventAccessApi.removeSelf(event.id);
            this._removeInvite(event);
        } finally {
            this.isBusy = false;
        }
    }

    public async acceptRegistration(event: EventEntity): Promise<void> {
        if (!event.associationId) { return; }
        this.isBusy = true;
        try {
            await this._associationApi.acceptInvite(event.associationId);
            this._removeInvite(event);
        } finally {
            this.isBusy = false;
        }
    }

    public async declineRegistration(event: EventEntity): Promise<void> {
        if (!event.associationId) { return; }
        this.isBusy = true;
        try {
            await this._associationApi.leave(event.associationId);
            this._removeInvite(event);
        } finally {
            this.isBusy = false;
        }
    }

    // Remove only the invite that was handled. The same event can be listed twice (a shared invite and a
    // participant invite), and the other one is still pending.
    private _removeInvite(invite: EventEntity): void {
        this.invites = this.invites.filter(e => e !== invite);
    }

    public back(): void {
        void this._router.load('my-events');
    }
}
